import { Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField } from "@mui/material";
import type { TripTagImage } from "@przezmorze/api-types";
import type { FC } from "react";
import { useState } from "react";
import AsyncLoadingButton from "../../components/asyncLoadingButton/AsyncLoadingButton";
import CancelButton from "../../components/cancelButton/CancelButton";
import ImagesPicker from "../../components/imagesPicker/ImagesPicker";
import LabelledCheckbox from "../../components/labelledCheckbox/LabelledCheckbox";
import { Select } from "../../components/select/Select";
import { useImages } from "../../media/useImages";
import type { TripTagCategory } from "./tripTagsApi";

const categories: TripTagCategory[] = [
  "Najpopularniejsze",
  "Kraj",
  "Na WWW",
  "Rodzaj grupy",
  "Transport",
  "Długość",
  "Inne",
];

interface DialogProps {
  readonly open: boolean;
  readonly category: TripTagCategory;
  readonly tagName: string;
  readonly isTagPopular: boolean;
  readonly tagImage?: TripTagImage;
  readonly onChange: (
    category: TripTagCategory,
    name: string,
    isPopular: boolean,
    tagImage?: TripTagImage,
  ) => Promise<void>;
  readonly onClose: () => void;
}

const EditTripTagDialog: FC<DialogProps> = ({
  open,
  category: initialCategory,
  tagName,
  isTagPopular,
  tagImage,
  onChange,
  onClose,
}) => {
  const [name, setName] = useState(() => tagName);
  const [category, setCategory] = useState(() => initialCategory);
  const [isPopular, setIsPopular] = useState(() => isTagPopular ?? false);
  const [image, setImage] = useState<TripTagImage[]>(tagImage ? [tagImage] : []);
  const { images, isLoading: imagesLoading } = useImages();

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>Edytuj tag zamówienia</DialogTitle>
      <DialogContent>
        <Stack
          direction="column"
          spacing={2}
          sx={{
            marginTop: 2,
          }}
        >
          <Select
            fullWidth
            label="Kategoria"
            values={categories.map((value) => ({ value }))}
            value={category}
            onSelect={setCategory}
          />
          <TextField label="Nazwa" value={name} onChange={(e) => setName(e.target.value)} fullWidth />
          <LabelledCheckbox label="Najpopularniejsze" checked={isPopular} onChange={setIsPopular} />
          <ImagesPicker
            label="Zdjęcie"
            limit={1}
            images={images}
            isLoading={imagesLoading}
            selectedImages={image}
            onSelectionChange={setImage}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <CancelButton onClick={onClose} />
        <AsyncLoadingButton
          disabled={
            name.trim().length === 0 ||
            (name === tagName &&
              category === initialCategory &&
              isPopular === isTagPopular &&
              image[0]?.id === tagImage?.id)
          }
          onClick={async () => {
            await onChange(category, name, isPopular, image[0]);
            onClose();
          }}
        >
          Zapisz
        </AsyncLoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default EditTripTagDialog;
